export enum States { 
    Creating,
    New,
    Todo,
    Running ,
    Over,
    Archived 
}